import React from "react";

// Reused from Employmentpage
import ModuleNavbar from "../Employmentpage/component/ModuleNavbar";

// Dashboard-specific components
import DashboardStatCards from "./component/DashboardStatCards";
import WorkforceMovementChart from "./component/WorkforceMovementChart";
import EmploymentTypeDonut from "./component/EmploymentTypeDonut";
import RecentActivity from "./component/RecentActivity";
import ContractStatusDonut from "./component/ContractStatusDonut";
import WorkScheduleDistribution from "./component/WorkScheduleDistribution";
import UpcomingContractExpiry from "./component/UpcomingContractExpiry";

// Data Hook
import useDashboardData from "./hooks/useDashboardData";

const Dashboard = () => {
  const dashboardData = useDashboardData("thisMonth");

  return (
    <div className="min-h-full flex flex-col bg-slate-50">
      {/* ── Top Navbar ─────────────────────────────────────────── */}
      <ModuleNavbar />

      {/* ── Page Content ───────────────────────────────────────── */}
      <div className="flex-1 w-full px-6 py-5 lg:px-8 space-y-5">

        {/* ── Stat Cards ─────────────────────────────────────── */}
        <DashboardStatCards stats={dashboardData.stats} />

        {/* ── Row 2: Workforce Movement + Work Schedule + Recent Activity ── */}
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 items-stretch">
          {/* Workforce Movement — spans 1 col */}
          <div className="lg:col-span-1 h-full">
            <WorkforceMovementChart data={dashboardData.workforce} />
          </div>

          {/* Work Schedule Distribution — spans 1 col */}
          <div className="lg:col-span-1 h-full">
            <WorkScheduleDistribution data={dashboardData.workSchedules} />
          </div>

          {/* Recent Activity — spans 1 col */}
          <div className="lg:col-span-1 h-full">
            <RecentActivity data={dashboardData.recentActivity} />
          </div>
        </div>

        {/* ── Row 3: Contract Status + Employment Type + Expiry ── */}
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 items-stretch">
          {/* Contract Status Donut */}
          <div className="lg:col-span-1 h-full">
            <ContractStatusDonut data={dashboardData.contractStatus} />
          </div>

          {/* Employment Type Donut */}
          <div className="lg:col-span-1 h-full">
            <EmploymentTypeDonut data={dashboardData.employmentTypes} />
          </div>

          {/* Upcoming Contract Expiry */}
          <div className="lg:col-span-1 h-full">
            <UpcomingContractExpiry data={dashboardData.contractExpiry} />
          </div>
        </div>

        {/* ── Footer ────────────────────────────────────────── */}
        <footer className="border-t border-slate-200 pt-4 pb-2 flex items-center justify-between text-xs text-slate-400">
          <span>© 2026 HRMS. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <button type="button" className="hover:text-slate-600 transition-colors">
              Privacy Policy
            </button>
            <span className="text-slate-200">|</span>
            <button type="button" className="hover:text-slate-600 transition-colors">
              Terms of Use
            </button>
            <span className="text-slate-200">|</span>
            <button type="button" className="hover:text-slate-600 transition-colors">
              Support
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Dashboard;
